import React from "react"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import Accordion from "react-bootstrap/Accordion"

const options = {
  renderText: text =>
    text.split("\n").flatMap((text, i) => [i > 0 && <br key={i} />, text]),
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: node => {
      return (
        <div>
          <GatsbyImage
            image={node.data.target.gatsbyImageData}
            alt={node.data.target.description}
          />
        </div>
      )
    },
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const internal = node.data.target.internalExternal
      const text = node.data.target.buttonText
      const type = node.data.target.internal.type
      return (
        <> 
          {type === "ContentfulAccordion" ? (
            <> 
              <h3>{node.data.target.title}</h3>
              <Accordion flush>
                {node.data.target.accordionSections.map((edge, index) => (
                  <Accordion.Item key={edge.id} eventKey={index.toString()}>
                    <Accordion.Header>
                        {edge.title}
                    </Accordion.Header>
                    <Accordion.Body>
                        <Rich text={edge.content} />
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </>
          ) : internal ? (
            <Link
              to={`/${node.data.target.internalLink.slug}`}
              className="buttons"
            >
              {text}
            </Link>
          ) : (
            <a
              href={node.data.target.externalLink}
              target="_blank"
              rel="noreferrer"
              className="buttons"
            >
              {text}
            </a>
          )}
        </>
      )
    },
    [INLINES.ENTRY_HYPERLINK]: (node, children) => {
      const type = node.data.target.internal.type
      return (
        <>
          {type === "ContentfulEvent" ? (
            <Link to={`/events/${node.data.target.slug}`}>{children}</Link>
            ) : (
            <Link to={`/${node.data.target.slug}`}>{children}</Link>
          )}
        </>
      )
    },
    [INLINES.HYPERLINK]: (node, children) => {
      return (
        <a href={node.data.uri} target="_blank" rel="noreferrer">
          {children}
        </a>
      )
    },
    [INLINES.ASSET_HYPERLINK]: (node, children) => {
      return (
        <a href={node.data.target.file.url} target="_blank" rel="noreferrer">
          {children}
        </a>
      )
    },
  },
}

const Rich = props => {
  return (
    <>
      {props.section ? (
        <section className={`richtext ${props.background === 'off-white' ? "fog" : "white"}${props.left ? " left" : " center"}`}>
          <div className="container">{renderRichText(props.text, options)}</div>
        </section>
      ) : (
        renderRichText(props.text, options)
      )}
    </>
  )
}

export default Rich
